import React from 'react';
import { Grid, Typography, withStyles } from '@material-ui/core';
import {
  SelectUI,
  ModuleCardTitleUI,
  CardModuleUI,
  ToggleUI,
} from '../../../common';

import { AtributosInputList } from './AtributosInputList';

const AtributosSection_ = (props) => {
  let {
    common,
    selects,
    classes,
    atributos_on,
    atributos_off,
    modalHandler,
    handleChangeSelect,
    handleChangeDynamicInput,
    handleOpcionesAvanzadasAtributos,
    handleChangeDeleteBloqueConAtributos,
    handleAgregarNuevoBloqueConAtributos,
  } = props;

  return (
    <CardModuleUI below>
      <Grid container spacing={24}>
        <ModuleCardTitleUI
          title="Atributos"
          subtitles={[
            'Sirven para productos que poseen diferentes atributos, por ejemplo: talle, color u otros.',
            'Vas a poder diferenciar el stock de tu producto en función a ellos y darle la posibilidad al cliente que elija entre ellos.',
          ]}
        />
        <Grid item xs={12}>
          <Grid
            container
            direction="row"
            justify="space-between"
            alignItems="center"
            spacing={8}
          >
            <Grid item sm={common.p_atributos.value === 1 ? 6 : 12} xs={12}>
              <SelectUI
                data={common.p_atributos}
                options={selects.p_atributos}
                handleChangeSelect={handleChangeSelect}
              />
            </Grid>
            <Grid item xs="auto">
              <ToggleUI show={common.p_atributos.value === 1}>
                <Typography
                  variant="subtitle1"
                  className={classes.editar_configuracion_box}
                >
                  <span
                    onClick={(e) =>
                      modalHandler(true, 'configurar_atributos', false)
                    }
                    className={classes.text_link}
                  >
                    {common.p_producto_digital.value
                      ? 'EDITAR PRECIO Y ATRIBUTOS'
                      : 'EDITAR PRECIO, ATRIBUTOS Y DIMENSIONES'}
                  </span>
                </Typography>
              </ToggleUI>
            </Grid>
          </Grid>
        </Grid>
        <ToggleUI show={common.p_atributos.value === 1}>
          <Grid item xs={12}>
            <AtributosInputList
              atributos_on={atributos_on}
              atributos_off={atributos_off}
              common={common}
              modalHandler={modalHandler}
              handleChangeDynamicInput={handleChangeDynamicInput}
              handleOpcionesAvanzadasAtributos={
                handleOpcionesAvanzadasAtributos
              }
              handleAgregarNuevoBloqueConAtributos={
                handleAgregarNuevoBloqueConAtributos
              }
              handleChangeDeleteBloqueConAtributos={
                handleChangeDeleteBloqueConAtributos
              }
            />
          </Grid>
        </ToggleUI>
        <ToggleUI
          show={common.p_atributos.value === 1 && atributos_on.stock.length > 0}
        >
          <Grid item>
            <Typography variant="subtitle1">
              <span
                onClick={handleAgregarNuevoBloqueConAtributos}
                className={classes.text_link}
              >
                AGREGAR MÁS VARIANTES
              </span>
            </Typography>
          </Grid>
        </ToggleUI>
      </Grid>
    </CardModuleUI>
  );
};

const styles = (theme) => ({
  text_link: {
    color: 'inherit',
    textDecoration: 'underline',
    cursor: 'pointer',
  },
  editar_configuracion_box: {
    marginTop: '10px',
    [theme.breakpoints.up('sm')]: {
      marginTop: '-15px',
    },
  },
});

export const AtributosSection = withStyles(styles, { withTheme: true })(
  AtributosSection_
);
